import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceProcessingPrintReview extends Layout {
    labelInvoiceCount: Label;
    labelInvoiceCountCaption: Label;
    labelLoadingImages: Label;
    labelPrintReview: Label;
    labelTotalInvoicedAmount: Label;
    labelTotalInvoicedAmountCaption: Label;
    panelMulticurrencyTotals: Panel;
    panelPrintReview: Panel;
    panelReportPreview: Panel;
    sourcePrintMiscInvoices: DataSource;
}
